import type { FocusEvent } from 'react';

type FocusableInput = HTMLInputElement | HTMLTextAreaElement;

export function placeInputCursorAtStart(
  event: FocusEvent<FocusableInput>,
  options?: { autoSelect?: boolean }
): void {
  const input = event.target;
  if (input.tagName !== 'INPUT' && input.tagName !== 'TEXTAREA') {
    return;
  }

  const apply = () => {
    if (!input) return;

    if (options?.autoSelect && input.value) {
      input.select();
      return;
    }

    // Do not force cursor to start on click — let the browser keep the user's clicked position.
    // Only auto-select when explicitly requested.
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setTimeout(apply, 0);
    });
  });
}
